/**
 * 시설(병의원·약국) 폐업일 표시.
 * closedOn != null 이면 폐업, null/빈 값이면 영업 중.
 */

export const isFacilityClosed = (closedOn?: string | null): boolean =>
  Boolean(closedOn?.trim());

/** 폐업일 셀 값. 영업 중이면 '-' */
export const formatClosedOnDisplay = (closedOn?: string | null): string => {
  const value = closedOn?.trim();
  return value || '-';
};

/**
 * 이름 옆 폐업 표기. 서버 RelatedPharmacy.display 와 동일.
 * 예: `루다약국(폐업 2026-09-10)`
 */
export const formatNameWithClosedOn = (
  name: string,
  closedOn?: string | null,
): string => {
  const label = name.trim() || '-';
  const closed = closedOn?.trim();
  return closed ? `${label}(폐업 ${closed})` : label;
};
